webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  methods: {
    onStartClick: function onStartClick(event) {
      __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit('startClick');
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'start',
  data: function data() {
    return {
      cal_id: 'parker2020.daniel@gmail.com',
      api_key: 'AIzaSyA2oeEEVzakpWKWGmc8vxyIF7wBzlKhuaI',
      calItems: [],
      error: '',
      timer: null,
      timerActiv: false,
      weekday: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      months: ['', 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
    };
  },

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on('startClick', this.onStartClick);
    Notification.requestPermission(function (status) {
      console.log('Notification permission status:', status);
    });
  },
  mounted: function mounted() {
    this.GetEvents();
  },
  methods: {
    buttonDescription: function buttonDescription() {
      return this.timerActiv ? 'Clear Timer' : 'Set Timer';
    },
    GetEvents: function GetEvents() {
      var _this = this;

      this.error = '';
      this.$http.get('https://www.googleapis.com/calendar/v3/calendars/' + this.cal_id + '/events?key=' + this.api_key + '&maxResults=10&singleEvents=true&orderBy=startTime&timeMin=' + this.getTimeMin()).then(function (response) {
        _this.calItems = response.body.items; // .sort((a, b) => new Date(a.start.dateTime) - new Date(b.start.dateTime))
      }, function (response) {
        _this.error = 'FEHLER';
        if (response.status === 422) {
          console.log(response);
        }
      });
    },
    clickButton: function clickButton() {
      if (!this.timerActiv) {
        var self = this;
        this.timer = setInterval(function () {
          self.pushNotification();
        }, 10000);
      } else {
        clearInterval(this.timer);
      }
      this.timerActiv = !this.timerActiv;
    },
    pushNotification: function pushNotification() {
      if (Notification.permission === 'granted') {
        console.log('PUSH NOTIFICATION');
        navigator.serviceWorker.getRegistration().then(function (reg) {
          if (reg) {
            reg.showNotification('Neuer Termin', {
              body: 'Ein neuer Termin steht an!',
              icon: '../../static/img/icons/android-chrome-192x192.png',
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              tag: 'vibration-sample'
            });
          }
        });
      }
    },
    getTimeMin: function getTimeMin() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
      var yyyy = today.getFullYear();
      // 2020-02-29T00:00:00Z
      return yyyy + '-' + mm + '-' + dd + 'T00:00:00Z';
    },
    onStartClick: function onStartClick() {
      this.GetEvents();
    },
    getStart: function getStart(item) {
      var d = new Date(item.start.dateTime);
      var dt = d.toLocaleString().replace(',', '').split(' ');
      var date = dt[0].split('.');
      var time = dt[1].split(':');
      return this.weekday[d.getDay()] + ' ' + this.pad_2(date[0]) + '. ' + this.months[date[1]] + ' um ' + time[0] + ':' + time[1] + 'Uhr';
    },
    pad_2: function pad_2(number) {
      return (number < 10 ? '0' : '') + number;
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(19);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_774f26d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(13);
function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_774f26d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{on:{"click":_vm.onStartClick}},[_c('img',{attrs:{"width":"24","height":"24","src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkAhoOIDXNzNokAAABTUlEQVQ4y92Tvy9DURzFz9MJgyZSkSYaEdLB0PgDJAYxEDoKg1GYtNjF6g8wSSQmI4Nd0q1dpCLa6NayECKWarUfw7v98W4vdmf63nfOue+e7/deTwEwpVXNKa5hNfWoB13p0nuSG0xwQQMbnxwTlSQi5Mh05Bt88BNeWWKEW4CWfI8mv6FBxS98+VoXVSBNgjADxNnixnZKYpx3s6qxjxfI5bFN1TacmrrOvKMVEQoBA2N8mTrtlOetI7FjqhIhhyFnZ+hTwnBHXsMxnKq1zug/gIzVBmcsNg17qJ5bk3XIQ5QMu2Ib8kQchl3DvtEfNBSd8gXqhj+QgoYaqeC88dinZtgyQ7YB4J4U0wwSZoY9iu3vdWb9PXxU/nhAddZbPzVRSbZfRS+eWe6eQ9aPSoyTdrzuXGeMdlJ5VkdiSmpRk4oKvehO1zr3yt2Kb1ejLiMVe2t3AAAAAElFTkSuQmCC"}}),_vm._v(" "),_c('span',[_vm._v("Daniels TT Kalender")]),_vm._v(" "),_c('span',{staticClass:"right"})]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start__ = __webpack_require__(16);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Start',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Start__["a" /* default */]
  }]
}));

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c6b3724_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__(18);
function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c6b3724_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.calItems),function(item,i){return _c('div',{key:i,staticClass:"event"},[_c('p',{staticClass:"start",domProps:{"innerHTML":_vm._s(_vm.getStart(item))}},[_vm._v(_vm._s(item.start))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.summary))]),_vm._v(" "),(item.description)?_c('p',{domProps:{"innerHTML":_vm._s(item.description)}}):_vm._e(),_vm._v(" "),(item.location)?_c('p',{staticClass:"location"},[_c('img',{attrs:{"width":"16","height":"16","src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkAhsRBCmH4+TlAAAA0UlEQVQoz3XRvUoDQRSG4Scu/gSscwsRBPEWUmpnYQqxVRDvQrFI562IIFgLK9pooRCvIaQQU2XFYzPu7kR9p5lzvhcOc4YfVpy6NzNTOrFsgZ5H0ToPeu24UKZgappud5Ya4VAIEztg10QIB41wLYT9uh4K4aoR3oRKt667KmGMNGeOIhOK1E3CEzqOauFYB8/NiIEQ5s709Z2rhDBoP/Q220IIN/mitn1mcWVrcZejTLjwizWvdfxi1R9seBfCh03/sOdLGObf1GZsXemy3foGiMxcFzuU04cAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDItMjdUMTc6MDQ6NDErMDA6MDCaR0qrAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTAyLTI3VDE3OjA0OjQxKzAwOjAw6xryFwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="}}),_vm._v("\n      "+_vm._s(item.location))]):_vm._e()])}),_vm._v(" "),(_vm.error.length > 0)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.d1db78639faa540cddf0.js